<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo de Fornecedor</span>
          <v-select
            :options="tiposFornecedor"
            name="tipoFornecedor"
            id="tipoFornecedor"
            v-model="selectTipoFornecedor"
            :onchange="
              (formCadastro.idTipoFornecedor = selectTipoFornecedor.id)
            "
            v-validate="{ required: true }"
            :state="validateState('Tipo de Fornecedor')"
            :class="validateClass('Tipo de Fornecedor')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Fantasia</span>
          <vs-input
            size="large"
            class="w-full"
            name="nomeFantasia"
            id="nomeFantasia"
            v-model="formCadastro.nomeFantasia"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('Nome Fantasia')"
            :danger="validateClass('Nome Fantasia')"
            val-icon-danger="clear"
            icon="icon-user"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Razão Social</span>
          <vs-input
            size="large"
            class="w-full"
            name="razaoSocial"
            id="razaoSocial"
            v-model="formCadastro.razaoSocial"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('Razão Social')"
            :danger="validateClass('Razão Social')"
            val-icon-danger="clear"
            icon="icon-user"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CPF / CNPJ</span>
          <vs-input
            size="large"
            class="w-full"
            name="CPF_CNPJ"
            id="CPF_CNPJ"
            v-model="formCadastro.cpf_cnpj"
            v-validate="{ required: true, max: 18 }"
            :state="validateState('CPF_CNPJ')"
            :danger="validateClass('CPF_CNPJ')"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            val-icon-danger="clear"
            icon="icon-user-check"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Telefone</span>
          <vs-input
            size="large"
            class="w-full"
            name="telefone"
            id="telefone"
            v-model="formCadastro.telefone"
            v-validate="{ min: 14 }"
            :state="validateState('telefone')"
            :danger="validateClass('telefone')"
            val-icon-danger="clear"
            v-mask="['(##) ####-####', '(##) #####-####']"
            icon="icon-smartphone"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Celular</span>
          <vs-input
            size="large"
            class="w-full"
            name="celular"
            id="celular"
            v-model="formCadastro.celular"
            v-validate="{ required: true, min: 15 }"
            :state="validateState('celular')"
            :danger="validateClass('celular')"
            val-icon-danger="clear"
            v-mask="'(##) #####-####'"
            icon="icon-smartphone"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Email</span>
          <vs-input
            size="large"
            class="w-full"
            name="email"
            id="email"
            v-model="formCadastro.email"
            v-validate="{ required: true, min: 6, email: true }"
            :state="validateState('email')"
            :danger="validateClass('email')"
            val-icon-danger="clear"
            icon="icon-mail"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CEP</span>
          <vs-input
            size="large"
            class="w-full"
            name="cep"
            id="cep"
            @keyup.native="buscaCEP"
            v-model="formCadastro.cep"
            v-validate="{ min: 10 }"
            :state="validateState('cep')"
            :danger="validateClass('cep')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'##.###-###'"
            icon-pack="feather"
            icon="icon-home"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Endereço</span>
          <vs-input
            size="large"
            class="w-full"
            name="endereco"
            id="endereco"
            v-model="formCadastro.endereco"
            v-validate="{ min: 6 }"
            :state="validateState('endereco')"
            :danger="validateClass('endereco')"
            val-icon-danger="clear"
            icon="icon-map-pin"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Número</span>
          <vs-input
            size="large"
            class="w-full"
            name="numero"
            id="numero"
            type="number"
            v-model="formCadastro.numero"
            v-validate="{ min: 1 }"
            :state="validateState('numero')"
            :danger="validateClass('numero')"
            val-icon-danger="clear"
            icon="icon-check-circle"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Complemento</span>
          <vs-input
            size="large"
            class="w-full"
            name="complemento"
            id="complemento"
            v-model="formCadastro.complemento"
            v-validate="{ min: 2 }"
            :state="validateState('complemento')"
            :danger="validateClass('complemento')"
            val-icon-danger="clear"
            icon="icon-check-circle"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Bairro</span>
          <vs-input
            size="large"
            class="w-full"
            name="bairro"
            id="bairro"
            v-model="formCadastro.bairro"
            v-validate="{ min: 3 }"
            :state="validateState('bairro')"
            :danger="validateClass('bairro')"
            val-icon-danger="clear"
            icon="icon-map-pin"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cidade</span>
          <vs-input
            size="large"
            class="w-full"
            name="cidade"
            id="cidade"
            v-model="formCadastro.cidade"
            v-validate="{ min: 3 }"
            :state="validateState('cidade')"
            :danger="validateClass('cidade')"
            val-icon-danger="clear"
            icon="icon-map"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Estado</span>
          <vs-input
            size="large"
            class="w-full"
            name="estado"
            id="estado"
            v-model="formCadastro.estado"
            v-validate="{ min: 2 }"
            :state="validateState('estado')"
            :danger="validateClass('estado')"
            val-icon-danger="clear"
            icon="icon-navigation"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Pix</span>
          <vs-input
            size="large"
            class="w-full"
            name="pix"
            id="pix"
            v-model="formCadastro.pix"
            val-icon-danger="clear"
            icon="icon-dollar-sign"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Banco</span>
          <vs-input
            size="large"
            class="w-full"
            name="banco"
            id="banco"
            v-model="formCadastro.banco"
            val-icon-danger="clear"
            icon="icon-dollar-sign"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Representante Legal</span>
          <vs-input
            size="large"
            class="w-full"
            name="representanteLegal"
            id="representanteLegal"
            v-model="formCadastro.representanteLegal"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('representanteLegal')"
            :danger="validateClass('representanteLegal')"
            val-icon-danger="clear"
            icon="icon-users"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idFornecedor == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from '../../locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import cpfCnpj from '../../services/cpfCnpj';
import { decryptData } from '../../services/decryptData';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },

  watch: {
    dados() {
      this.preencheForm();
    },
  },

  data() {
    return {
      aguardeCadastro: false,
      tiposFornecedor: [],
      selectTipoFornecedor: {},
      formCadastro: {
        status: true,
        idFornecedor: null,
        idTipoFornecedor: null,
        nomeFantasia: null,
        razaoSocial: null,
        cpf_cnpj: null,
        telefone: null,
        celular: null,
        email: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pix: null,
        banco: null,
        representanteLegal: null,
      },
    };
  },

  methods: {
    async preencheForm() {
      this.resetForm();
      this.$vs.loading();

      await this.buscaDadosSelects(
        'buscar-tipos-fornecedor',
        'tiposFornecedor',
        'tipoFornecedor',
        'idTipoFornecedor',
      );

      this.$vs.loading.close();

      if (this.dados.idFornecedor) {
        this.formCadastro.idFornecedor = this.dados.idFornecedor;

        this.selectTipoFornecedor = this.tiposFornecedor.find(
          (item) => item.id === this.dados.idTipoFornecedor,
        );
        this.formCadastro.idTipoFornecedor = this.selectTipoFornecedor.id;

        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nomeFantasia = this.dados.nomeFantasia;
        this.formCadastro.razaoSocial = this.dados.razaoSocial;
        this.formCadastro.cpf_cnpj = this.dados.cpf_cnpj;
        this.formCadastro.telefone = this.dados.telefone;
        this.formCadastro.celular = this.dados.celular;
        this.formCadastro.email = this.dados.email;
        this.formCadastro.cep = this.dados.cep;
        this.formCadastro.endereco = this.dados.endereco;
        this.formCadastro.numero = this.dados.numero;
        this.formCadastro.complemento = this.dados.complemento;
        this.formCadastro.bairro = this.dados.bairro;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.pix = this.dados.pix;
        this.formCadastro.banco = this.dados.banco;
        this.formCadastro.representanteLegal = this.dados.representanteLegal;
      }
    },

    buscaCEP() {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        const cep = this.formCadastro.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cep,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      let action, method;
      if (!this.formCadastro.idFornecedor) {
        action = 'adicionar-fornecedor';
        method = 'post';
      } else {
        action = `atualizar-fornecedor/${this.formCadastro.idFornecedor}`;
        method = 'put';
      }

      // validação
      if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cpf_cnpj) === false) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `CPF/CNPJ inválido`,
          color: 'danger',
        });

        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[method]('fornecedor', action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },

    resetForm() {
      this.selectTipoFornecedor = {};
      this.formCadastro = {
        status: true,
        idFornecedor: null,
        idTipoFornecedor: null,
        nomeFantasia: null,
        razaoSocial: null,
        cpf_cnpj: null,
        telefone: null,
        celular: null,
        email: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pix: null,
        banco: null,
        representanteLegal: null,
      };
    },

    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },

    async buscaDadosSelects(rota, array, campoDescricao, campoPK) {
      this[array] = [];

      await service.getAll('fornecedor', {}, rota).then(({ data }) => {
        data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
  },

  mounted() {
    this.$validator.localize('ptBr', locale);
  },

  components: {
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
